import { Component, OnInit } from '@angular/core';
import { FuseConfigService } from '../../../../../core/services/config.service';
import { FuseTranslationLoaderService } from '../../../../../core/services/translation-loader.service';

import { locale as english } from '../../../../i18n/en';
import { locale as spanish } from '../../../../i18n/es';

@Component({
    selector   : 'fuse-error-403',
    templateUrl: './error-403.component.html',
    styleUrls  : ['./error-403.component.scss']
})
export class FuseError403Component implements OnInit
{
    constructor(
        private fuseConfig: FuseConfigService,
        private translationLoader: FuseTranslationLoaderService,
    )
    {
        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar   : 'none',
                footer    : 'none'
            }
        });

        // this.translationLoader.loadTranslations(english, spanish);
    }

    ngOnInit()
    {
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/errors/403/error-403.component.ts